import { InjectionToken } from '@angular/core';
import { IEnvironment, IRuntimeEnvironment } from 'interfaces-lib';

export const ENVIRONMENT = new InjectionToken<Partial<IEnvironment>>('environment');
export const RUNTIME_ENVIRONMENT = new InjectionToken<IRuntimeEnvironment | undefined>('runtimeEnvironment');
